module.exports = __webpack_public_path__ + "img/aiQue.1b2663e8.png";